import { useEffect } from 'react';
import i18n from 'i18n';

function syncDocumentMeta(language) {
  document.documentElement.lang = language;
  document.title = i18n.t('meta.title', { lng: language });
  const description = document.querySelector('meta[name="description"]');
  if (description) {
    description.setAttribute('content', i18n.t('meta.description', { lng: language }));
  }
}

function LocaleSync() {
  useEffect(() => {
    syncDocumentMeta(i18n.resolvedLanguage || i18n.language);

    const handleLanguageChanged = (language) => {
      syncDocumentMeta(language);
    };

    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, []);

  return null;
}

export default LocaleSync;
